//Taken from Chips component

//returns string
export default function shortNotation(value: number) {
	return (
		value >= 1000000000 ? value / 1000000000 + "B" :
		
		value >= 1000000 ?
			((Math.floor(value / 1000000 * 10) / 10) + "M") +
			((value % 100000 > 0) ? "+" : "") :
		
		value >= 1000 ?
			((Math.floor(value / 1000 * 10) / 10) + "K") +
			((value % 100 > 0) ? "+" : "") :
		
		value
	);
}